import { getMappedLanguage } from 'i18n/helpers';
import { KNOWLEDGE_BASE_CONFIG_ENDPOINT } from './constants';

export const makeGetKnowledgeBaseConfigEndpoint = (
  knowledgeBaseId: string,
  lang?: string,
) => {
  const mappedLang = getMappedLanguage(lang);
  return `/p/v4/kb/knowledge-bases/${knowledgeBaseId}?chat=true&lang=${mappedLang}` as typeof KNOWLEDGE_BASE_CONFIG_ENDPOINT;
};
